<template>
    <td-dialog :title="$t(title)" :before-close="colsedlalog" :visible="isvisible" @cancel="colsedlalog" :close-on-click-modal="false" :close-on-press-escape="false" width="800px" top="18vh">
        <el-container>
            <el-header>
                <el-form :inline="true" class="demo-form-inline" ref="fromDevice">
                    <el-form-item :label="$t('common.DEVICE_NAME')">
                        <td-input v-model="fromDevice.sName"></td-input>
                    </el-form-item>
                    <!-- <el-form-item :label="$t('common.IP')">
                        <td-input v-model="fromDevice.ip"></td-input>
                    </el-form-item> -->
                    <el-form-item class="paddingLeft10">
                        <td-button type="primary" :loading="loading" @click="btnClickQuery">{{ $t('common.QUERY') }}</td-button>
                        <td-button type="button" @click="btnDeleteBatch">{{ $t('common.BATCH_RELIEVE') }}</td-button>
                        <td-button type="button" @click="btnAddLink"> {{ $t('common.ADD_LINK') }}</td-button>
                    </el-form-item>
                </el-form>
            </el-header>
            <el-main>
                <td-table
                    :columns="columns"
                    :hasIndex="false"
                    :dataSource="tableData"
                    :pageSize="pageSize"
                    :currentPage="currentPage"
                    :total="total"
                    :rowKey="rowKey"
                    :hasLoading="hasLoading"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentChange"
                    :hasPage="true"
                    height="400"
                    ref="listDevice"
                ></td-table>
                <dialogOrgDevTree
                    v-if="orgDeviceTreeVisible"
                    :title="addTitle"
                    :dialogOrgVisible="orgDeviceTreeVisible"
                    :imgloading="true"
                    :checkStrictly="true"
                    :deviceTypeList="hostType"
                    @orgDialogClose="orgDialogClose"
                    @selected="selected"
                    ref="dialogOrgTree"
                ></dialogOrgDevTree>
            </el-main>
        </el-container>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
import dialogOrgDevTree from './dialogOrgDevTree.vue';
export default {
    components: { dialogOrgDevTree },
    props: {
        title: {
            type: [String, Number]
        },
        // 页面是否显示
        isvisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 组织id
        orgId: {
            type: String
        },
        // 文件存储服务器设备主键
        fileStorage: {
            type: Object,
            default: function() {
                return null;
            }
        },

        parentDevType: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    mounted() {},
    created() {
        this.btnQuery();
        this.queryFileAdatperLinkDevice();
    },
    data() {
        return {
            addDevceAvailable: false,
            fromDevice: {
                ip: '',
                sname: ''
            },
            addTitle: '',
            loading: false,
            hasLoading: false,
            rowKey: 'sId',
            orgDeviceTreeVisible: false,
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            hostType: [],
            total: 0, // 总条数,
            columns: [
                {
                    prop: 'sDeviceName',
                    label: 'common.DEVICE_NAME',
                    align: 'center'
                },

                {
                    prop: 'sDeviceTypeName',
                    label: 'common.DEVICE_TYPE',
                    align: 'center'
                },

                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.sDeviceId);
                                        }
                                    }
                                },
                                this.$t('common.RELIEVE')
                            )
                        ]);
                    }
                }
            ],
            tableData: []
        };
    },

    methods: {
        // 添加
        btnAddLink() {
            this.$log.info('btnAddLink');
            this.addTitle = 'common.LINK_DEVICE'; // 标题
            this.orgDeviceTreeVisible = true;
        },
        // 批量解除
        btnDeleteBatch() {
            let row = this.$refs.listDevice.getSelectAllRows();
            if (row.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE'), type: 'warning' });
                return;
            }
            let sDeviceIdList = [];
            row.forEach(element => {
                sDeviceIdList.push(element.sDeviceId);
            });
            let param = {
                sFileStorageId: this.fileStorage.sId,
                sDeviceIdList: sDeviceIdList
            };
            this.deleteDeviceRelation(param);
        },
        //查询点击按钮
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 删除关联
        delete(id) {
            let sDeviceIdList = [];
            sDeviceIdList.push(id);
            let param = {
                sFileStorageId: this.fileStorage.sId,
                sDeviceIdList: sDeviceIdList
            };
            this.deleteDeviceRelation(param);
        },
        // 查询
        btnQuery() {
            this.loading = true;
            this.hasLoading = true;
            let param = {
                sFileStorageId: this.fileStorage.sId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true,
                sDeviceName: this.fromDevice.sName
                // sIp: this.fromDevice.ip
            };
            resourceApi.queryDeviceRelation(JSON.stringify(param), response => {
                this.loading = false;
                this.hasLoading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }

                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        queryFileAdatperLinkDevice() {
            this.hasLoading = true;
            resourceApi.queryFileAdatperLinkDevice('', response => {
                this.loading = false;
                this.hasLoading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }

                if (response.data.content) {
                    response.data.content.forEach(val => {
                        this.hostType.push(val.iDeviceType);
                    });
                }
            });
        },
        saveDeviceRelation(params) {
            this.hasLoading = true;
            resourceApi.saveDeviceRelation(JSON.stringify(params), response => {
                this.hasLoading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                if (response.data.content) {
                    this.$message({ showClose: true, message: response.data.content, type: 'warning' });
                } else {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                }

                this.submit();
            });
        },
        deleteDeviceRelation(params) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    resourceApi.deleteDeviceRelation(JSON.stringify(params), response => {
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });

                            return;
                        }
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(e => {
                    this.$log.error('/device/deleteDevice', e);
                });
        },
        // 组织树形回调
        selected(node) {
            if (node && node.length > 0) {
                let param = {
                    sFileStorageId: this.fileStorage.sId,
                    deviceList: node
                };
                this.saveDeviceRelation(param);
            }
        },
        // 提交之后
        submit() {
            if (this.currentPage === []) {
                this.currentPage = 1;
            }
            this.btnQuery();
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        // 关闭窗口之前需要调用的方法
        colsedlalog() {
            this.$log.info('colsedlalog');
            this.$emit('colsedlalog');
        },
        closeDlogBatchhost() {
            this.$log.info('closeDlogBatchhost');
            this.addDevceAvailable = false;
            // this.btnSearch();
        },

        orgDialogClose() {
            this.$log.info('orgDialogClose');
            this.orgDeviceTreeVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
